import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class RenderReport extends Form {

    constructor(data = {}) {
        super({});

        this.report_parameters = {};
        this.report_structure = false;

        this.resetReportRender();
   }

    resetReportRender() {
        this.report_job = false;
        this.resetReportPreview();
    }

    resetReportPreview() {
        this.report_results = false;
    }

    previewReport(append = false) {
        let self = this;
        let uri = self.api_prefix + '/report/' + self.report_structure.id + '/preview';

        return new Promise((resolve, reject) => {
            axios.post(uri, self.report_parameters)
                .then(response => {
                    self.report_results = response.data;

                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * Show Report
     *
     * @param id
     * @returns {Promise<unknown>}
     */
    showReport(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get(this.api_prefix + '/report/' + id, self.data)
                .then(response => {
                    self.report_structure = response.data.data;

                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * Check to see if Report has Parameter Fields
     *
     * @returns {boolean}
     */
    hasRenderFields() {
        let self = this;

        // Set the default export driver (CSV)
        self.report_parameters['export_driver'] = 'MBLSolutions\\Report\\Driver\\QueuedExport\\CsvQueuedExport';

        if (self.report_structure) {
            self.report_structure.fields.forEach(function (field) {
                self.report_parameters[field.alias] = null;
            });

            return self.report_structure.fields.length > 0;
        }

        return false;
    }

    /**
     * Render Queued Report
     *
     * @param id
     * @returns {Promise<unknown>}
     */
    renderQueuedReport(id) {
        let self = this;

        self.resetFormMessages().then(r => self.setFormUpdating());

        return new Promise((resolve, reject) => {
            axios.post(this.api_prefix + '/report/queue/' + id, self.report_parameters)
                .then(response => {
                    self.report_job = response.data;

                    self.setFormUpdateComplete();

                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * Get the Report Job Status
     *
     * @param uuid
     * @returns {Promise<unknown>}
     */
    reportJob(uuid) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get(this.api_prefix + '/report/queue/job/' + uuid)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
        });
    }

}
